module.exports = __webpack_public_path__ + "static/img/top.56b256bc.webp";